import React, { createContext, useEffect, useRef, useState } from "react";
import Map from "./Map";
import { _FeatureCollection, _FlightData } from "./Models/commonModel";
import config from "./config.json";
import { buildGeoJson } from "./utils/util";
import _ from "lodash";
import moment from "moment";
import { Snackbar, MuiThemeProvider } from "@material-ui/core";
import getTheme from "./styles/theme";
import { createStyles, makeStyles } from "@material-ui/styles";
export interface _MapStyle {
  label: string;
  value: string;
  url: string;
  mbtitlesUrl: string;
}

export interface _ViewPort {
  latitude: number;
  longitude: number;
  zoom: number;
}

interface _SearchLatLong {
  latitude: number;
  longitude: number;
}
interface _GlobalContext {
  isLive: boolean;
  setIsLive: (value: boolean) => void;
  bulkUpdate: (flights: _FlightData[], date: string) => void;
  flightFeatureCollection: _FeatureCollection;
  searchFlightData: string;
  setSearchFlightData: React.Dispatch<React.SetStateAction<string>>;
  currentMapStyle: _MapStyle;
  setCurrentMapStyle: React.Dispatch<React.SetStateAction<_MapStyle>>;
  viewPort: _ViewPort;
  setViewPort: React.Dispatch<React.SetStateAction<_ViewPort>>;
  showSnackBar: (message: string) => void;
  setIsShowForm: React.Dispatch<React.SetStateAction<boolean>>;
  isShowForm: boolean;
  currentTime: string;
  setCurrentTime: React.Dispatch<React.SetStateAction<string>>;
  isLiveRef: React.MutableRefObject<boolean>;
  setFlightFeatureCollection: (data: _FeatureCollection) => void;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  searchViewPort: _SearchLatLong;
  setSearchViewPort: React.Dispatch<React.SetStateAction<_SearchLatLong>>;
  isAgreedTerms: boolean;
  setIsAgreedTerms: React.Dispatch<React.SetStateAction<boolean>>;
  isShowTermsAlert: boolean;
  setIsShowTermsAlert: React.Dispatch<React.SetStateAction<boolean>>;
}

export const GlobalContext = createContext<_GlobalContext>(
  null as unknown as _GlobalContext
);




const App = () => {
  const [isLive, setIsLiveState] = useState(true);
  const isLiveRef = useRef<boolean>(true);
  const [viewPort, setViewPort] = useState(config.airportCoordinates);
  const [flightFeatureCollection, setFlightFeatureCollectionState] =
    useState<_FeatureCollection>({
      type: "FeatureCollection",
      features: [],
    });

  const flightFeatureCollectionRef = useRef<_FeatureCollection>({
    type: "FeatureCollection",
    features: [],
  });
  const [searchFlightData, setSearchFlightData] = useState<string>("");
  const [currentMapStyle, setCurrentMapStyle] = useState<_MapStyle>(
    config.mapStyles[0]
  );
  const [snackBar, setSnackBar] = useState({
    isShow: false,
    message: "",
  });
  const [isShowForm, setIsShowForm] = useState(false);
  const [isAgreedTerms, setIsAgreedTerms] = useState(false);
  const [isShowTermsAlert, setIsShowTermsAlert] = useState(false);
  const [currentTime, setCurrentTime] = useState<string>(
    moment().format("MM/DD/YYYY h:mm:ss a")
  );

  const setIsLive = (value: boolean) => {
    setIsLiveState(value);
    isLiveRef.current = value;
  };

  const setFlightFeatureCollection = (data: _FeatureCollection) => {
    flightFeatureCollectionRef.current = data;
    setFlightFeatureCollectionState(data);
  };

  const [loading, setIsLoading] = useState(true);

  const [searchViewPort, setSearchViewPort] = useState<_SearchLatLong>({
    latitude: 0,
    longitude: 0,
  });



  useEffect(() => {
    const timer = setInterval(() => {
      let time = Date.now();
      _.remove(flightFeatureCollection.features, (e) => {
        return e.properties.timestamp < time - 10000;
      });
    }, 10000);
    return () => clearInterval(timer);
  }, [5000]);

  const bulkUpdate = (flights: _FlightData[], date: string) => {
    setCurrentTime(date);
    for (let index = 0; index < flights.length; index++) {
      const flight = flights[index];
      const flightFeature = buildGeoJson(flight);
      const flightIndex = flightFeatureCollectionRef.current.features.findIndex(
        (item) => item.properties.aid === flight.aid
      );
      if (flightIndex === -1) {
        flightFeatureCollectionRef.current.features.push(flightFeature);
      } else {
        // const tempFeatureCollection = _.cloneDeep(flightFeatureCollection);
        if (
          flightFeature.properties.head === 0 ||
          flightFeature.properties.head === undefined
        ) {
          flightFeature.properties.head =
            flightFeatureCollectionRef.current.features[
              flightIndex
            ].properties.head;
        }
        flightFeatureCollectionRef.current.features.splice(
          flightIndex,
          1,
          flightFeature
        );
      }
    }
    setFlightFeatureCollectionState({
      ...flightFeatureCollection,
      features: [...flightFeatureCollectionRef.current.features],
    });
  };

  const styles = useStyles()


  const handleClose = () => {
    setSnackBar({
      isShow: false,
      message: "",
    });
  };

  const showSnackBar = (message: string) => {
    setSnackBar({
      isShow: true,
      message,
    });
  };

  return (
    <GlobalContext.Provider
      value={{
        isLive,
        setIsLive,
        bulkUpdate,
        flightFeatureCollection,
        searchFlightData,
        setSearchFlightData,
        currentMapStyle,
        setCurrentMapStyle,
        viewPort,
        setViewPort,
        showSnackBar,
        setIsShowForm,
        isShowForm,
        setCurrentTime,
        isLiveRef,
        currentTime,
        setFlightFeatureCollection,
        setIsLoading,
        loading,
        searchViewPort,
        setSearchViewPort,
        isAgreedTerms,
        setIsAgreedTerms,
        isShowTermsAlert,
        setIsShowTermsAlert
      }}
    >
      <MuiThemeProvider theme={getTheme()}>
        <Map />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={snackBar.isShow}
          onClose={handleClose}
          message={snackBar.message}
          key={snackBar.message}
          autoHideDuration={3000}
         ContentProps={{
          classes: {
            root: styles.root
          }
        }}
        />
      </MuiThemeProvider>
    </GlobalContext.Provider>
  );
};


const useStyles = makeStyles((theme: any) => {
  return createStyles({
    root: {
     fontSize: '15px',
     backgroundColor: config.backgroundColor,
     color: 'white'
    }
  });
});

export default App;


